var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLayoutMain)?_c('LayoutMain',[_vm._t("default")],2):_c('LayoutBlank',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }